import type { ReactElement } from 'react';
import Banner from 'components/shared/Banner';

import useCurrentUser from 'hooks/useCurrentUser';

type Props = {
  centered: boolean;
  onClick: () => void;
};

function GiftUserPaymentBanner({ centered, onClick }: Props): ReactElement {
  const { currentUser } = useCurrentUser();
  const { credit } = currentUser;

  return (
    <Banner
      isCentered={centered}
      button={(
        <button
          className="c-button c-button--secondary"
          type="button"
          onClick={onClick}
        >
          Add Payment
        </button>
    )}
    >
      <strong>
        You&apos;ve exceeded your $
        <span>
          {credit}
          &nbsp;
        </span>
        credit amount. Please add a payment method to continue.
      </strong>
    </Banner>
  );
}

export default GiftUserPaymentBanner;
